import React, { useEffect, useState } from 'react';
import { BreathAPIs } from '../APIs/BreathAPIs';
import styles from './Support.module.css';
import { toast, ToastContainer } from 'react-toastify';
import { ConfigProvider, Pagination, Spin } from 'antd';
import SupportTicket from './components/SupportTicket';

const Support = (props) => {

    const [isLoading, setIsLoading] = useState(false);
    const [supportTickets, setSupportTickets] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        current: 1,
        pageSize: 10,
        totalPages: 0
    });

    const getSupportTickets = async (page = 1, pageSize = 10) => {
        setIsLoading(true);
        try {
            const res = await BreathAPIs.getUserSupportTicketList({ page, limit: pageSize, filterFromDate:'', filterToDate:'', filterStatus:'' });
            console.log(res);
            setSupportTickets(res.data.supportTickets);
            setPagination({
                total: res.data.pagination.total,
                current: res.data.pagination.current,
                pageSize: res.data.pagination.pageSize,
                totalPages: res.data.pagination.totalPages
            });
        } catch (error) {
            console.error(error);
            toast.error('Error fetching support tickets.');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getSupportTickets();
    }, []);

    const handlePageChange = (page, pageSize) => {
        getSupportTickets(page, pageSize);
    };

    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: '#18365E',
                colorBgContainer: '#fff',
            },
        }}>
            <div className='container mb-5 mb-md-6 mt-3'>
                <ToastContainer />
                <div className={styles['support-layout']}>
                    <div className={styles['main-head']}>
                        <h2>Issue Tracker</h2>
                    </div>

                    <div className={styles["support-container"]}>
                        {isLoading ? (
                            <div className={styles['is-page-loading']}>
                                <Spin size="large" />
                            </div>
                        ) : supportTickets.length > 0 ? (
                            supportTickets.map((ticket) => (
                                <SupportTicket key={ticket.id} ticket={ticket} />
                            ))
                        ) : (
                            <p>No support tickets found.</p>
                        )}
                    </div>

                    <div className={styles['pagination']}>
                        <Pagination
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={pagination.total}
                            onChange={handlePageChange}
                            showSizeChanger
                            onShowSizeChange={handlePageChange}
                        />
                    </div>

                </div>
            </div>
        </ConfigProvider>
    );
}

export default Support;
